<template>
  <div>
    <!-- 遮罩层 -->
    <van-overlay :show="isLoad" :z-index="zIndex" class-name="overlay_style" :custom-style="customStyle">
      <van-loading type="spinner" color="#00adef" text-color="#00adef" vertical>加载中...</van-loading>
    </van-overlay>
  </div>
</template>

<script>
  export default {
    props: {
      isLoad: {
        type: Boolean,
        default: false
      },
      zIndex: {
        type: Number,
        default: 100
      },
      customStyle: {
        type: Object,
        default: {}
      }
    },
    data() {
      return {

      }
    }
  }
</script>

<style lang="scss" scoped>
.overlay_style {
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>
